export default {
  title: "Авторизация",
  register: "У меня еще нет профиля",
  forgotPassword: "Забыли свой пароль?",
  helper: " Нет доступа в личный кабинет?",
  helperText:
    "Доступ в ЛК предоставляется менеджером выставки только после заключения договора. Вы получите письмо, которое позволит активировать все возможности личного кабинета.",
  submit: "Войти",
  error: {
    email: "Введите Вашу электронную почту",
    userNotFound: "Неправильный логин или пароль",
    emailNotConfirmed: "Ваш Email не подтвержден"
  }
};
